import Typography from '@mui/material/Typography';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import theme from '@ui/theme';
import Image from 'next/image';
import React from 'react';

import useStyles from './TeamMember.style';

export interface TeamMemberProps {
  name: string;
  title: string;
  image: string;
  description?: string;
}

const TeamMemberAlt = (props: TeamMemberProps) => {
  const { name, title, image } = props;
  const { md } = useBreakpoints();
  const { classes } = useStyles();
  const src = image || 'https://placehold.it/300x400/cacaca/cacaca';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: md ? 'flex-start' : 'center'
      }}
    >
      <div
        className={classes.imageContainer}
      >
        <Image
          fill
          src={src}
          objectFit={md ? 'cover' : 'cover'}
          alt=""
          sizes="100vw"
        />
      </div>

      <div
        style={{
          textAlign: md ? 'left' :'center'
        }}
      >
        <Typography
          variant="h5"
          style={{ fontWeight: 450, margin: theme.spacing(1.5, 0, 0.5) }}
        >
          {name}
        </Typography>

        <Typography
          variant="subtitle1"
          style={{ fontWeight: 400 }}
        >
          {title}
        </Typography>
      </div>

    </div>
  );
};

export default TeamMemberAlt;
